import React from 'lib/react';
import { EVButton } from 'lib/components';
import { useTranslation } from 'lib/translation';
import { Link } from 'lib/router';
import { ORDER_ROUTE } from 'constants/RouteConstants';
import { useSelector } from 'lib/redux';
import { VIEWPOINT_URL } from 'constants/AppConstants';

function LogInButton() {
  const { t } = useTranslation();

  const geocodedAddress = useSelector(({ orderAddresses }) => orderAddresses.geocodedAddress);
  const addressParams = geocodedAddress ? `?latitude=${geocodedAddress.latitude}&longitude=${geocodedAddress.longitude}` : '';

  return (
    <EVButton
      style={{ display: 'flex', padding: '14px 16px', color: '#61687D' }}
      type={Link}
      href={`${VIEWPOINT_URL}/myev${ORDER_ROUTE}${addressParams}`}
    >
      {t('unauthenticated__login_Btn')}
    </EVButton>
  );
}

export default LogInButton;
